import type { ActiveLocationGroup } from "@/lib/timeline/location";
import {
  debuggablesForActiveLocationGroup,
  onStagePlaceLabels,
} from "@/lib/timeline/location";
import type { BoardModelDebugMeasureContext } from "../measurable";
import { syncBoardModelDebuggables, type EnsureDebugFrame } from "../sync";
import type { DebugFrameIdSets } from "../register";
import { updateLocationCohortLabel } from "../ActiveLocationGroup/cohortLabel";
import { applyTrunkActiveLocationGroupDebug } from "./trunkSync";

export function applyActiveLocationGroupDebug(
  host: HTMLElement,
  context: BoardModelDebugMeasureContext,
  groups: readonly ActiveLocationGroup[],
  idSets: DebugFrameIdSets,
  ensureFrame: EnsureDebugFrame,
): void {
  const layout = context.layout;
  const playheadMs = context.playheadMs;
  for (const group of groups) {
    const debuggables = debuggablesForActiveLocationGroup(
      group,
      layout,
      playheadMs,
    );
    if (debuggables.length === 0) {
      continue;
    }
    syncBoardModelDebuggables(host, ensureFrame, debuggables, context, idSets);
    updateLocationCohortLabel(
      context.world,
      group.id,
      onStagePlaceLabels(layout, group, playheadMs),
    );
  }
  applyTrunkActiveLocationGroupDebug(
    host,
    context,
    groups,
    idSets,
    ensureFrame,
  );
}
